module.exports = __webpack_public_path__ + "why14.png?e1811a102e3e6ee11afaf8c6fdce9177";